import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Layout from '../pages/layout'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      component: Layout,
      redirect: '/main',
      hidden: false,
    },
    {
      path: '/mobile',
      name: 'mobile',
      hidden: false,
      component: () => import('../pages/mobile.vue'),
      meta: {
        keepAlive: false,
        title: "移动端"
      }
    },
    {
      id: 1,
      //pid: 0,
      path: '/main',
      name: 'main',
      hidden: true,
      component: Layout,
      redirect: '/Home',
      //component: Layout,
      //  redirect: '/charts/DiscountFigure',
      //redirect: () => import('../pages/Home.vue'),
      meta: {
        keepAlive: true,
        title: "首页",
        metaInfo: {
          title: "首页",
          keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
        }
      }
    },
    {
      id: 2,
      //pid: 0,
      path: '/Course',
      name: 'Course',
      hidden: true,
      component: Layout,
      meta: {
        keepAlive: true,
        title: "课程中心",
        metaInfo: {
          title: "课程中心",
          keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
        }
      },
      children: [{
          id: 21,
          pid: 2,
          path: '/Online',
          name: 'Online',
          hidden: true,
          component: () => import('../pages/GoodsList.vue'),
          meta: {
            keepAlive: true,
            title: "网络课程",
            metaInfo: {
              title: "网络课程",
              keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
            }
          }
        },
        {
          id: 22,
          //pid: 2,
          path: '/Offline',
          name: 'Offline',
          hidden: true,
          component: () => import('../pages/GoodsList.vue'),
          meta: {
            keepAlive: true,
            title: "线下课程"
          }
        },
        {
          id: 23, //显示首页用
          //pid: 0,
          path: '/Home',
          name: 'Home',
          hidden: true,
          component: () => import('../pages/Home.vue'),
          meta: {
            keepAlive: false,
            //title: "首页"
          }
        },
        {
          id: 24, //商品详情
          //pid: 0,
          path: '/GoodsInfo',
          name: 'GoodsInfo',
          hidden: true,
          component: () => import('../pages/GoodsInfo.vue'),
          meta: {
            keepAlive: true,
            //title:"首页"
          }
        },
        {
          id: 25, //显示首页用
          //pid: 0,
          path: '/about',
          name: 'about',
          hidden: true,
          component: () => import('../pages/about.vue'),
          meta: {
            keepAlive: false,
            //title: "首页"
          }
        },
        {
          id: 26, //显示首页用
          //pid: 0,
          path: '/join',
          name: 'join',
          hidden: true,
          component: () => import('../pages/join.vue'),
          meta: {
            keepAlive: false,
            //title: "首页"
          }
        },
        {
          id: 27, //显示首页用
          //pid: 0,
          path: '/winnerinfo',
          name: 'winnerinfo',
          hidden: true,
          component: () => import('../pages/winnerinfo.vue'),
          meta: {
            keepAlive: false,
            //title: "首页"
          }
        },
        {
          id: 28, //显示首页用
          //pid: 0,
          path: '/match',
          name: 'match',
          hidden: true,
          component: () => import('../pages/match.vue'),
          meta: {
            keepAlive: false,
            //title: "首页"
          }
        },
      ]
    },

    {
      id: 3,
      //pid: 0,
      path: '/Mall',
      name: 'Mall',
      hidden: true,
      component: Layout,
      meta: {
        keepAlive: true,
        title: "向日葵商城"
      },
      children: [{
          id: 31,
          //pid: 3,
          path: '/Instrument',
          name: 'Instrument',
          hidden: true,
          component: () => import('../pages/GoodsList.vue'),
          meta: {
            keepAlive: true,
            title: "乐器商城"
          }
        },
        {
          id: 32,
          //pid: 3,
          path: '/Books',
          name: 'Books',
          hidden: true,
          component: () => import('../pages/GoodsList.vue'),
          meta: {
            keepAlive: true,
            title: "图书及周边商城"
          }
        },
        {
          id: 33,
          //pid: 3,
          path: '/settlement',
          name: 'settlement',
          hidden: false,
          component: () => import('../pages/settlement.vue'),
          meta: {
            keepAlive: true,
            title: "结算"
          }
        },
        {
          id: 34,
          //pid: 3,
          path: '/pay',
          name: 'pay',
          hidden: false,
          component: () => import('../pages/pay.vue'),
          meta: {
            keepAlive: true,
            title: "结算"
          }
        },
      ]
    },

    {
      id: 9,
      //pid: 0,
      path: '/joining',
      name: 'joining',
      hidden: true,
      component: Layout,
      redirect: '/join',
      meta: {
        keepAlive: true,
        title: "加盟合作",
        metaInfo: {
          title: "加盟合作",
          keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
        }
      }
    },
    {
      id: 10,
      //pid: 0,
      path: '/matchs',
      name: 'matchs',
      hidden: true,
      component: Layout,
      redirect: '/match',
      meta: {
        keepAlive: true,
        title: "大赛&集训营",
        metaInfo: {
          title: "大赛&集训营",
          keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
        }
      }
    },
    {
      id: 91,
      //pid: 0,
      path: '/winner',
      name: 'winner',
      hidden: true,
      component: Layout,
      redirect: '/winnerinfo',
      meta: {
        keepAlive: true,
        title: "学员奖项",
        metaInfo: {
          title: "学员奖项",
          keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
        }
      }
    },
    {
      id: 8,
      //pid: 0,
      path: '/abouts',
      name: 'abouts',
      hidden: true,
      component: Layout,
      redirect: '/about',
      meta: {
        keepAlive: true,
        title: "关于我们",
        metaInfo: {
          title: "关于我们",
          keywords: "向日葵钢琴城,钢琴教学,钢琴,向日葵,阳光朵拉陪练",
        }
      }
    },
    {
      id: 4,
      //pid: 0,
      path: '/me',
      name: 'me',
      hidden: false,
      component: Layout,
      meta: {
        keepAlive: false,
        //title:"首页"
      },
      children: [{
          id: 41,
          pid: 4,
          path: '/shoppingcart',
          name: 'shoppingcart',
          hidden: false,
          component: () => import('../pages/shoppingcart.vue'),
          meta: {
            keepAlive: true,
            title: "购物车"
          }
        },
        {
          id: 42,
          pid: 4,
          path: '/CoursewareList',
          name: 'CoursewareList',
          hidden: false,
          component: () => import('../pages/CoursewareList.vue'),
          meta: {
            keepAlive: true,
            title: "我的课程"
          }
        },
        {
          id: 43,
          pid: 4,
          path: '/myorder',
          name: 'myorder',
          hidden: false,
          component: () => import('../pages/myorder.vue'),
          meta: {
            keepAlive: true,
            title: "我的订单"
          }
        },
        {
          id: 44,
          pid: 4,
          path: '/logout',
          name: 'logout',
          hidden: false,
          component: () => import('../pages/Home.vue'),
          meta: {
            keepAlive: true,
            title: "退出"
          }
        },
        {
          id: 49,
          pid: 4,
          path: '/addressInfo',
          name: 'addressInfo',
          hidden: false,
          component: () => import('../pages/addressInfo.vue'),
          meta: {
            keepAlive: false,
            title: "添加地址"
          }
        },

      ]
    },
    {
      id: 99,
      //pid: 0,
      path: '/login',
      name: 'login',
      hidden: true,
      component: () => import('../pages/login.vue'),
      meta: {
        keepAlive: true,
        title: "登录/注册"
      }
    },

    {
      id: 100,
      //pid: 0,
      path: '/adduserinfo',
      name: 'adduserinfo',
      hidden: false,
      component: () => import('../pages/adduserinfo.vue'),
      meta: {
        keepAlive: false,
        //title:"首页"
      }
    },
    {
      id: 101,
      //pid: 0,
      path: '/Franchisee',
      name: 'Franchisee',
      hidden: true,
      beforeEnter() {
        location.href = 'http://47.92.251.188:8091/Login'
      },
      meta: {
        keepAlive: false,
        title: "加盟商登录"
      }
    },

    {
      id: 102,
      //pid: 0,
      path: '/CoursewareInfo',
      name: 'CoursewareInfo',
      hidden: false,
      component: () => import('../pages/CoursewareInfo.vue'),
      meta: {
        keepAlive: false,
        //title:"首页"
      }
    },
    {
      id: 103,
      //pid: 0,
      path: '/privacyagreement',
      name: 'privacyagreement',
      hidden: false,
      component: () => import('../pages/privacyagreement.vue'),
      meta: {
        keepAlive: false,
        title: "隐私协议"
      }
    },
    {
      id: 103,
      //pid: 0,
      path: '/privacyagreement_t',
      name: 'privacyagreement_t',
      hidden: false,
      component: () => import('../pages/privacyagreement_t.vue'),
      meta: {
        keepAlive: false,
        title: "隐私协议"
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js